import classNames from 'classnames';
import type { ReactNode } from 'react';
import { COPY } from '../../../assets/copy/copy.js';
import {
  CheckmarkCheckedIcon,
  CheckmarkUncheckedIcon,
  LockIcon,
} from '../../../assets/svgs/index.js';
import styles from './TaskList.module.scss';

export function TaskItem({
  children,
  completed = false,
  endIcon,
  locked = false,
}: {
  children: ReactNode;
  completed?: boolean;
  endIcon?: ReactNode;
  locked?: boolean;
}): JSX.Element {
  return (
    <li
      title={locked ? COPY.TOOLTIPS.LOCKED_TASK : undefined}
      className={classNames(styles['task-item'], {
        [styles['completed']]: completed,
        [styles['locked']]: locked,
      })}
    >
      {locked ? (
        <div className={styles['icon-wrapper']}>
          <LockIcon role="img" aria-label="locked" />
        </div>
      ) : completed ? (
        <div className={styles['icon-wrapper']}>
          <CheckmarkCheckedIcon role="img" aria-label="completed" />
        </div>
      ) : (
        <div className={styles['icon-wrapper']}>
          <CheckmarkUncheckedIcon role="img" aria-label="not completed" />
        </div>
      )}
      <div className={styles['task-title']}>{children}</div>
      {endIcon && <div>{endIcon}</div>}
    </li>
  );
}

export function TaskList({
  children,
}: {
  children: ReactNode | ReactNode[];
}): JSX.Element {
  return <ul className={styles['task-list']}>{children}</ul>;
}
